module.exports = __webpack_public_path__ + "img/public_resources_rotate_white.b5ea55e9.svg";